import request from '@/utils/requestold'

/**
 * 获取竞赛主页内容
 * @param {*} data 
 * 【必填 competition_id】
 */
export function selectCompetition(data) {
	return request({
		url: '/api/contest/select_competition',
		method: 'post',
		data
	})
}

/**
 * 首页数据展示
 * $data 参数传递 
 * 【必填 competition_id】
 */
export function selectPathData(data) {
	return request({
		url: '/api/create/select_path',
		method: 'post',
		data
	})
}

/**
 * 创建或编辑目标
 * @param {*} data 
 * 【必填 competition_id,target_title,target_id】
 */
export function saveTargetTitleData(data) {
	return request({
		url: '/api/create/save_target',
		method: 'post',
		data
	})
}

/**
 * 首页课程目标-目标删除
 * $data 参数传递 
 * 【必填 target_id】
 */
export function deleteTargetData(data) {
	return request({
		url: '/api/create/delete_target',
		method: 'post',
		data
	})
}

/**
 * 首页数据--保存目标--项目标题
 * @param {*} data 
 * 【必填 target_id,id,project_name,project_desc】img_url,percent
 */
export function saveTargetProjectTitleData(data){
    return request({
		url: '/api/create/save_project',
		method: 'post',
		data
	})
}

/**
 * 首页课程目标-项目删除
 * @param {*} data 
 * 【必填 project_id】
 */
export function deleteProjectData(data){
    return request({
		url: '/api/create/delete_project',
		method: 'post',
		data
	})
}

/**
 * 任务创建或编辑保存
 * @param {*} data 
 * 【必填 project_id task_name】
 */
export function saveTargetProjectTaskTitleData(data){
    return request({
		url: '/api/create/save_task',
		method: 'post',
		data
	})
}

/**
 * 任务删除
 * @param {*} data
 * 【必填 task_id】 
 */
export function deleteTaskSettingData(data){
    return request({
		url: '/api/create/delete_task',
		method: 'post',
		data
	})
}

/**
 * 活动(试卷)创建或者编辑
 * @param {*} data 
 * 【必填 task_id paper_title】
 */
export function saveTargetProjectTaskAddActivityData(data){
    return request({
		url: '/api/create/save_event',
		method: 'post',
		data
	})
}

/**
 * 活动(试卷)数据获取
 * @param {*} data
 * 【必填 paper_id activity_type：4】
 */
export function selectTargetProjectTaskActivityData(data){
    return request({
		url: '/api/create/select_event',
		method: 'post',
		data
	})
}
/**
 * 活动(试卷)删除
 * @param {*} data 
 * 【必填 paper_id】
 */
export function deleteTargetProjectTaskActivityData(data){
    return request({
		url: '/api/create/delete_event',
		method: 'post',
		data
	})
}

/**
 * 修改活动(试卷)标题
 * @param {*} data 
 * 【必填 paper_id  paper_title】
 */
export function savePaperTitleData(data){
    return request({
		url: '/api/create/save_title',
		method: 'post',
		data
	})
}

/**
 * 获取试卷所有题型类型
 * @param {*} data
 * 【必填 paper_id】
 */
export function selectSinglePaperData(data){
    return request({
		url: '/api/create/select_paper',
		method: 'post',
		data
	})
}

/**
 * 获取试卷单个题型类型所有题目数据
 * @param {*} data 
 * 【必填 paper_id  paper_type】
 */
export function selectPaperTypeTopic(data){
    return request({
		url: '/api/create/select_papertype',
		method: 'post',
		data
	})
}
/**
 * 单题保存数据
 * @param {*} data 
 * 【必填 paper_id paper_type score 如果是实训需要传：training_title，其他类型则传：topic_title，answer，parsing】
 */
export function savePaperTopicContent(data){
    return request({
		url: '/api/create/save_item',
		method: 'post',
		data
	})
}

/**
 * 单题删除
 * @param {*} data
 * 【必填 paper_content_id paper_type】 
 */
export function deletePaperTopicContentData(data){
    return request({
		url: '/api/create/delete_item',
		method: 'post',
		data
	})
}

/**
 * 保存单张试卷内容，题目类型排序，题目排序
 * @param {*} data 
 */
export function saveSinglePaperData(data){
    return request({
        url: '/api/create/save_paper',
		method: 'post',
		data
    })
}

/**
 * 试卷预览
 * @param {*} data 
 * 【必填 paper_id】
 */
export function testPreviewData(data){
    return request({
        url: '/api/create/paper_preview',
		method: 'post',
		data
    })
}

/**
 * 修改分值占比 目标/项目/任务/活动通用
 * @param {*} data 
 * 【必填 percent id type 】type为修改的类型，1为目标，2为项目，3为任务，4为活动
 */
export function resetPercent(data){
    return request({
        url: '/api/create/reset_percent',
		method: 'post',
		data
    })
}

/**
 * 比赛内容保存
 * @param {*} data 
 * 【必填 competition_id targetSort projectSort taskSort eventSort】
 */
export function savePathData(data){
    return request({
        url: '/api/create/save_path',
		method: 'post',
		data
    }) 
}

/**
 * 项目拖拽后保存变动
 * @param {*} data 
 * 【必填 competition_id target_id projectInfo】
 */
export function projectDragToRefreshData(data){
    return request({
        url: '/api/create/drag_project',
		method: 'post',
		data
    }) 
}

/**
 * 任务拖拽后保存变动
 * @param {*} data 
 * 【必填 competition_id project_id taskInfo】
 */
export function taskDragToRefreshData(data){
    return request({
        url: '/api/create/drag_task',
		method: 'post',
		data
    }) 
}

/**
 * 活动拖拽后保存变动
 * @param {*} data 
 * 【必填 competition_id task_id eventInfo】
 */
export function itemDragToRefreshData(data){
    return request({
        url: '/api/create/drag_item',
		method: 'post',
		data
    }) 
}


/**
 * 报名比赛
 * @param {*} data 
 * 【必填 competition_id student_name school dapartment student_number reason】
 */
export function applyForCompetition(data){
	return request({
        url: '/api/contest/apply_competition',
		method: 'post',
		data
    }) 
}

/**
 * 参与重现赛的首页
 * @param {*} data 
 * 【必填 competition_id replay_type】
 */
export function selectReplayData(data){
	return request({
        url: '/api/contest/replay',
		method: 'post',
		data
    }) 
}

/**
 * 创建重现赛
 * @param {*} data 
 */
export function createReplay(data){
	return request({
        url: '/api/contest/create_replay',
		method: 'post',
		data
    }) 
}

/**
 * 查看重现赛历史记录
 * @param {*} data 
 */
export function replayHistory(data){
	return request({
        url: '/api/contest/replay_history',
		method: 'post',
		data
    }) 
}



/**
 * 查询题型名称,中文
 * @param {*} data 为题型类别
 */
export function returnQuestionType(data) {
	if(data===1){
		return '单选题'
	}else if(data===2){
		return '多选题'
	}else if(data===3){
		return '判断题'
	}else if(data===4){
		return '填空题'
	}else if(data===5){
		return '选词填空题'
	}else if(data===6){
		return '连线题'
	}else if(data===7){
		return '名词解释题'
	}else if(data===8){
		return '简答题'
	}else if(data===9){
		return '实训题'
	}else if(data===10){
		return '排序题'
	}
}

/**
 * 查询题型名称,英文
 * @param {*} data 为题型类别
 */
export function returnType(data) {
	if(data===1){
		return 'singleChoice'
	}else if(data===2){
		return 'multipleChoice'
	}else if(data===3){
		return 'jugeMent'
	}else if(data===4){
		return 'fill'
	}else if(data===5){
		return 'gapFill'
	}else if(data===6){
		return 'line'
	}else if(data===7){
		return 'explain'
	}else if(data===8){
		return 'short'
	}else if(data===9){
		return 'train'
	}else if(data===10){
		return 'multipleSort'
	}
}

/**
 * 阿拉伯数字转中文
 */
export function NumberToChinese(num){
	var arr1 = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
    var arr2 = new Array('', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿');//可继续追加更高位转换值
    if(!num || isNaN(num)){
        return "零";
    }
    var english = num.toString().split("")
    var result = "";
    for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i;//倒序排列设值
        result = arr2[i] + result;
        var arr1_index = english[des_i];
        result = arr1[arr1_index] + result;
    }
    //将【零千、零百】换成【零】 【十零】换成【十】
    result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
    //合并中间多个零为一个零
    result = result.replace(/零+/g, '零');
    //将【零亿】换成【亿】【零万】换成【万】
    result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
    //将【亿万】换成【亿】
    result = result.replace(/亿万/g, '亿');
    //移除末尾的零
    result = result.replace(/零+$/, '')
    //将【一十】换成【十】
    result = result.replace(/^一十/g, '十');
    return result;
}